import template from './views/dashboard.tpl.html';

angular
    .module('festzelt-os.dashboard')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.dashboard', {
            url: '/dashboard',
            templateUrl: template,
            controller: 'DashboardCtrl',
            controllerAs: 'vm',
            data: {
                pageTitle: 'Dashboard',
                hideBreadcrumb: true,
                fullWidth: true
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/dashboard-routes.js